type RequestId = string;
const sainUsageEventStore: Map<RequestId, true> = new Map();
const MAX_EVENTS = 10;

// React listeners for useSyncExternalStore
const listeners = new Set<() => void>();

function emitChange() {
	listeners.forEach((listener) => listener());
}

export function subscribe(listener: () => void) {
	listeners.add(listener);
	return (): boolean => listeners.delete(listener);
}

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function getSnapshot(): Map<RequestId, true> {
	return sainUsageEventStore;
}

/**
 * Marks a requestId as fired.
 * Maintains only the last MAX_EVENTS request IDs.
 */
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function markFired(requestId: RequestId): void {
	if (!sainUsageEventStore.has(requestId)) {
		sainUsageEventStore.set(requestId, true);

		if (sainUsageEventStore.size > MAX_EVENTS) {
			const oldestKey = sainUsageEventStore.keys().next().value;
			if (oldestKey) {
				sainUsageEventStore.delete(oldestKey);
			}
		}

		emitChange();
	}
}
